"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TicketService = void 0;
const api_1 = require("./api");
const PATH = 'inquiry/api';
const GAME_PATH = 'game/api';
const PATH_V2 = 'inquiry/api/v2';
class TicketService {
    static async checkInstantTicketBarCode(barcode, tenantKey) {
        try {
            return await api_1.API.get({
                url: `${PATH}/ticket/check/instant?barCode=${barcode}`,
                headers: {
                    'X-Tenant-Key': tenantKey
                }
            });
        }
        catch (error) {
            throw error;
        }
    }
    static async checkDrawTicketBarCode(barcode, tenantKey) {
        try {
            return await api_1.API.get({
                url: `${PATH}/ticket/check/draw?barCode=${barcode}`,
                headers: {
                    'X-Tenant-Key': tenantKey
                }
            });
        }
        catch (error) {
            throw error;
        }
    }
    static async checkQuickDrawTicketBarCode(barcode, tenantKey) {
        try {
            return await api_1.API.get({
                url: `${PATH}/ticket/check/quickdraw?barCode=${barcode}`,
                headers: {
                    'X-Tenant-Key': tenantKey
                }
            });
        }
        catch (error) {
            throw error;
        }
    }
    static async checkQuickCardTicketBarCode(barcode, tenantKey) {
        try {
            return await api_1.API.get({
                url: `${PATH}/ticket/check/quickcard?barCode=${barcode}`,
                headers: {
                    'X-Tenant-Key': tenantKey
                }
            });
        }
        catch (error) {
            throw error;
        }
    }
    static async checkFastPlayTicketBarCode(barcode, tenantKey) {
        try {
            return await api_1.API.get({
                url: `${PATH}/ticket/check/fastplay?barCode=${barcode}`,
                headers: {
                    'X-Tenant-Key': tenantKey
                }
            });
        }
        catch (error) {
            throw error;
        }
    }
    static async checkCashOnlineBarCode(barcode) {
        try {
            return await api_1.API.post({
                url: `${GAME_PATH}/ticket/check-cash-online`,
                body: {
                    barcode
                }
            });
        }
        catch (error) {
            throw error;
        }
    }
    static async checkCashInstantBarCode(barcode) {
        try {
            return await api_1.API.post({
                url: `${GAME_PATH}/ticket/check-cash-instant`,
                body: {
                    barcode
                }
            }).then(response => response);
        }
        catch (error) {
            throw error;
        }
    }
    static async checkMNScratchTicketBarCode(barcode, tenantKey) {
        try {
            return await api_1.API.get({
                url: `${PATH}/ticket/check/instant?barCode=${barcode}`,
                headers: {
                    'X-Tenant-Key': tenantKey
                }
            });
        }
        catch (error) {
            throw error;
        }
    }
    static async checkMNLottoTicketBarCode(barcode, tenantKey) {
        try {
            return await api_1.API.get({
                url: `${PATH}/ticket/check/draw?barCode=${encodeURIComponent(barcode)}`,
                headers: {
                    'X-Tenant-Key': tenantKey
                }
            });
        }
        catch (error) {
            throw error;
        }
    }
    static async checkInstantTicketBarCodeV2(barcode, tenantKey) {
        try {
            return await api_1.API.get({
                url: `${PATH_V2}/ticket/check/instant?barCode=${barcode}`,
                headers: {
                    'X-Tenant-Key': tenantKey
                }
            });
        }
        catch (error) {
            throw error;
        }
    }
    static async checkDrawTicketBarCodeV2(barcode, tenantKey) {
        try {
            return await api_1.API.get({
                url: `${PATH_V2}/ticket/check/draw?barCode=${barcode}`,
                headers: {
                    'X-Tenant-Key': tenantKey
                }
            });
        }
        catch (error) {
            throw error;
        }
    }
    static checkPromoCodeBarCode(barcode, tenantKey) {
        try {
            console.warn('checking barcode {} for tenantKey {}', barcode, tenantKey);
            return barcode;
        }
        catch (error) {
            throw error;
        }
    }
    static async checkScratchTicketBarCode(barcode, tenantKey) {
        try {
            return await api_1.API.get({
                url: `${PATH}/ticket/check/instant?barCode=${barcode}`,
                headers: {
                    'X-Tenant-Key': tenantKey
                }
            });
        }
        catch (error) {
            throw error;
        }
    }
}
exports.TicketService = TicketService;
//# sourceMappingURL=ticket-service.js.map